import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Button as BaseButton, Text } from "rebass";

import { CONTENT_ITEM_HEIGHT } from "./settings";
import { ActiveInstance } from "../../../../utils/Instance/types";
import { ActionType } from "./types";

import { showModal } from "../../../../store/modules/modal/actions";

interface Props {
  actionType: ActionType;
  instance: ActiveInstance;
}

const Button = styled(BaseButton)`
  transition: background-color .4s;

  &:hover {
    background-color: ${({ theme }) => theme.colors["sp-gray2"]};
  }
`;

export const ContentItem: React.FC<Props> = ({ actionType, instance }) => {
  const dispatch = useDispatch();
  const handleOnClick = useCallback(() => {
    dispatch(showModal(actionType, instance));
  }, [dispatch, actionType, instance]);

  return (
    <Button
      type="button"
      width={1}
      height={`${CONTENT_ITEM_HEIGHT}px`}
      borderRadius="0"
      bg="transparent"
      color="zodiac"
      onClick={handleOnClick}
    >
      <Text textAlign="left">{actionType}</Text>
    </Button>
  );
};
